import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";
import { widthSubNav } from "@/components/layout/SubNav/SubNav";
import { LoadingIcon } from "@/assets/icons";

interface IframeScreenProps {
  url: string;
}

const IframeScreen = ({ url }: IframeScreenProps) => {
  const [postMessage, setPostMessage] = useState<MessageEvent>();
  const [isShowOverlay, setIsShowOverlay] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    window.addEventListener("message", (ev: MessageEvent) => {
      setPostMessage(ev.data);

      if (ev.data.message === "appConnected") {
        setIsLoading(false);
      }
    });
  }, []);

  useEffect(() => {
    if (!postMessage) return;
    if (typeof postMessage.data !== "object") return;
    if (!postMessage.data.type) return;
    if (
      postMessage.data?.message === "updateURL" &&
      postMessage.data?.payload?.pathname
    ) {
      if (postMessage.data?.message === "showDialog" && !isShowOverlay) {
        setIsShowOverlay(true);
      } else if (postMessage.data?.message === "hiddenDialog") {
        setIsShowOverlay(false);
      }
    }
  }, [postMessage]);

  return (
    <>
      {isShowOverlay ? (
        <div
          className={cn(
            "fixed inset-0 z-50 bg-background/80 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
          )}
          style={{ width: widthSubNav }}
        ></div>
      ) : null}
      <div className="min-h-[calc(100vh-90px)] h-[calc(100vh-90px)] w-full relative">
        {isLoading && (
          <div className="absolute inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0">
            <LoadingIcon className="animate-spin duration-[3000ms] mx-auto" />
          </div>
        )}
        <iframe
          id="iframeLibrary"
          className="h-full w-full"
          title="Thư viện"
          src={url}
        ></iframe>
      </div>
    </>
  );
};

export default IframeScreen;
